import { ethers } from 'ethers';
import FixedTermsTokenEscrowAbi from './FixedTermsTokenEscrow.abi.json';

const ABI = FixedTermsTokenEscrowAbi as ethers.InterfaceAbi;

export function getEscrowContract(
  signerOrProvider: ethers.Signer | ethers.Provider,
  escrowAddress: string
): ethers.Contract {
  return new ethers.Contract(escrowAddress, ABI, signerOrProvider);
}

export interface EscrowState {
  tokenA: string;
  tokenB: string;
  depositorOfA: string;
  depositorOfB: string;
  amountA: bigint;
  amountB: bigint;
  deadline: bigint;
  senderOfADeposited: boolean;
  senderOfBDeposited: boolean;
  senderOfAClaimed: boolean;
  senderOfBClaimed: boolean;
  isFunded: boolean;
  isExpired: boolean;
}

export async function getEscrowState(
  provider: ethers.Provider,
  escrowAddress: string
): Promise<EscrowState> {
  const contract = getEscrowContract(provider, escrowAddress);
  const [
    tokenA,
    tokenB,
    depositorOfA,
    depositorOfB,
    amountA,
    amountB,
    deadline,
    senderOfADeposited,
    senderOfBDeposited,
    senderOfAClaimed,
    senderOfBClaimed,
    isFunded,
    isExpired,
  ] = await Promise.all([
    contract.tokenA(),
    contract.tokenB(),
    contract.depositorOfA(),
    contract.depositorOfB(),
    contract.amountA(),
    contract.amountB(),
    contract.deadline(),
    contract.senderOfADeposited(),
    contract.senderOfBDeposited(),
    contract.senderOfAClaimed(),
    contract.senderOfBClaimed(),
    contract.isFunded(),
    contract.isExpired(),
  ]);
  return {
    tokenA,
    tokenB,
    depositorOfA,
    depositorOfB,
    amountA,
    amountB,
    deadline,
    senderOfADeposited,
    senderOfBDeposited,
    senderOfAClaimed,
    senderOfBClaimed,
    isFunded,
    isExpired,
  };
}

export async function depositTokenA(signer: ethers.Signer, escrowAddress: string): Promise<ethers.TransactionResponse> {
  const contract = getEscrowContract(signer, escrowAddress);
  return contract.depositTokenA();
}

export async function depositTokenB(signer: ethers.Signer, escrowAddress: string): Promise<ethers.TransactionResponse> {
  const contract = getEscrowContract(signer, escrowAddress);
  return contract.depositTokenB();
}

export async function claimTokenA(signer: ethers.Signer, escrowAddress: string): Promise<ethers.TransactionResponse> {
  const contract = getEscrowContract(signer, escrowAddress);
  return contract.claimTokenA();
}

export async function claimTokenB(signer: ethers.Signer, escrowAddress: string): Promise<ethers.TransactionResponse> {
  const contract = getEscrowContract(signer, escrowAddress);
  return contract.claimTokenB();
}

export async function refundTokenA(signer: ethers.Signer, escrowAddress: string): Promise<ethers.TransactionResponse> {
  const contract = getEscrowContract(signer, escrowAddress);
  return contract.refundTokenA();
}

export async function refundTokenB(signer: ethers.Signer, escrowAddress: string): Promise<ethers.TransactionResponse> {
  const contract = getEscrowContract(signer, escrowAddress);
  return contract.refundTokenB();
}
